import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {PaymentQrCodeService} from "../service/payment-qr-code-service";
import {PaymentQrCodeResponse} from "../interface/PaymentQrCodeResponse";
import {PAYMENT_QR_IDENTIFICATION_ID} from "../constants/global.constants";

@Component({
  selector: 'app-user-card-payment-qr-page',
  templateUrl: './user-card-payment-qr-page.component.html',
  styleUrl: './user-card-payment-qr-page.component.scss'
})
export class UserCardPaymentQrPageComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private paymentQrCodeService: PaymentQrCodeService
  ) {}

  ngOnInit(): void {
    const paymentQrIdentificationId = this.route.snapshot.paramMap.get(PAYMENT_QR_IDENTIFICATION_ID);
    if (!paymentQrIdentificationId) {
      this.router.navigate(['/error-page']);
      return;
    }

    this.paymentQrCodeService.checkAndExpireQRCode(paymentQrIdentificationId).subscribe({
      next: (response: PaymentQrCodeResponse) => {
        if (!response.userCardId || !response.amount || response.isCommissionActive === undefined) {
          this.router.navigate(['/error-page']);
          return;
        }

        this.router.navigate(['/', response.userCardId, 'payment'], {
          queryParams: {
            amount: response.amount.toString(),
            isCommissionActive: response.isCommissionActive
          }
        });
      },
      error: () => {
        this.router.navigate(['/error-page']);
      }
    });
  }
}
